import React from 'react';
import {withRouter} from 'react-router';
import config from '../../assets/js/conf/config.js';
import '../../assets/css/common/cart/subheader.css';

class SubHeader extends React.Component{
	componentDidMount(){

	}
    goBack(){
    	let pathname = this.props.location.pathname;
    	if(localStorage['search'] == 1){
    		this.props.history.goBack();
    		//this.props.history.replace(config.path+'searcgDetail?keywords='+localStorage['searchKeywords']);
    	}else if (pathname === '/addressIndex/index'){
            this.props.history.replace(config.path+'balance/index');
        }else if ((pathname === '/video/detail' || pathname === '/video/other') && localStorage['bottomIndex'] == 1){
            this.props.history.replace('/home/index');
        }else if ((pathname === '/video/detail' || pathname === '/video/other') && localStorage['bottomIndex'] == 2){
            this.props.history.replace('/home/cart');
        }else if ((pathname === '/video/detail' || pathname === '/video/other') && localStorage['bottomIndex'] == 3){
            this.props.history.replace('/home/college');
        }else{
            this.props.history.goBack();
        }
    }
    getClick(){
      this.props['onClickRightBtn']();
    }
    render(){
        return(
            <div className={'sub-header'}>
                <div className={'back'} onClick={this.goBack.bind(this)}></div>
                <div className={'title'} id={'title'}>{this.props.title}</div>
                <div className={this.props['right-text']!==''?'right-btn':'right-btn hide'} onClick={this.getClick.bind(this)}>{this.props['right-text']}</div>
            </div>
        );
    }
}
export default withRouter(SubHeader);